module.exports = __webpack_public_path__ + "img/car.3396421e.svg";